import { render, staticRenderFns } from "./SecondBlockServices.vue?vue&type=template&id=4dcb3794"
import script from "./SecondBlockServices.vue?vue&type=script&lang=js"
export * from "./SecondBlockServices.vue?vue&type=script&lang=js"
import style0 from "./SecondBlockServices.vue?vue&type=style&index=0&id=4dcb3794&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports